import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import SvgImage from "../../../Icons/Icons";
import DataTable from "react-data-table-component";
import ReactPaginate from "react-paginate";
import {
  changeTxnStatusBank,
  cleanViewBankStatement,
  viewBankStatement,
} from "../../../../services/Store/Actions/TripsAction";
import { BallTriangle } from "react-loader-spinner";
import moment from "moment";
import DriverDashboardAddExpense from "../../../Modals/DriverDashboardAddExpense";
import EditLedgerExpense from "../../../Modals/EditLedgerExpense";
import MapCustomerLedger from "../MapCustomerLedger";
import { DatePickerField } from "../../../core/inputs/input";
import { useNavigate } from "react-router-dom";
import { storeDataToAsyncStorage } from "../../../../services/Utils/functions";

function ViewBankStatment(props) {
  const { toggle, modal, setModal, customerId } = props;
  const dispatch = useDispatch();
  const [offset, setOffset] = useState(0);
  const [transferType, setTransferType] = useState("0");
  const [mode, setMode] = useState("0");
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [sortedField, setSortedField] = useState("Transaction Date");
  const [sortDirection, setSortDirection] = useState(null);
  const navigate = useNavigate();

  const { bankStatementList, bankStatementCount, bankStatementListLoader } =
    useSelector((state) => state?.trip);
  const txnCount = bankStatementCount;
  const pageCount =
    txnCount % 10 === 0 ? txnCount / 10 : Math.floor(txnCount / 10) + 1;

  const handleClose = () => {
    setModal(!modal);
  };
  const [addExpense, setAddExpense] = useState(false);
  const [statement, setStatement] = useState(null);

  const closeAddExpense = () => {
    setAddExpense(false);
  };

  const toggleAddExpense = () => {
    setAddExpense(!addExpense);
  };

  const showAddExpense = (val) => {
    setAddExpense(true);
  };

  const [addCustomerTxn, setCustomerTxn] = useState(false);

  const closeCustomerTxn = () => {
    setCustomerTxn(false);
  };

  const toggleACustomerTxn = () => {
    setCustomerTxn(!addCustomerTxn);
  };

  const showCustomerTxn = (val) => {
    setCustomerTxn(true);
  };
  useEffect(() => {
    dispatch(
      viewBankStatement({
        offset: offset,
        limit: 10,
        bankId: props.bankId,
        from: from,
        to: to,
        sortBy: sortedField == "Transaction Date" ? "expDate" : "",
        sortAs: sortDirection == "asc" ? "ASC" : "DESC",
        transferType: transferType,
        mode: mode,
        //   from : from,
        //   to : to,
        //   transferType : tripType == "0" ? "credit" : tripType == "1" ? "debit" : "",
        // startTime: moment(startDate).format("MM/DD/YYYY"),
        // endTime: moment(endDate).format("MM/DD/YYYY"),
        // search: search,
        // status: status,
      })
    );
    return () => {
      dispatch(cleanViewBankStatement());
    };
  }, [
    props.bankId,
    from,
    to,
    sortedField,
    offset,
    transferType,
    mode,
    sortDirection,
  ]);
  const handleSort = (column) => {
    let directionsSet;
    console.log("nhsheiohr", column);
    setSortedField(column?.name);
    if (sortDirection) {
      directionsSet = sortDirection == "asc" ? "desc" : "asc";
      setSortDirection(sortDirection == "asc" ? "desc" : "asc");
    } else {
      directionsSet = "asc";
      // Set the initial sort direction for a different column
      setSortDirection("asc");
    }
    // dispatch(
    //   viewBankStatement({
    //     offset: 0,
    //     limit: 10,
    //     bankId: props.bankId,
    //     sortBy : column?.name == "Transaction Date" ? "expDate" : "amount",
    //     sortAs : directionsSet == "asc" ? "ASC" : "DESC"
    //   })
    // );
  };

  const CustomSortIcon = () => {
    console.log("kmdkfmper", sortDirection);
    if (sortDirection == "asc") {
      return <SvgImage name={"arrowUp"} />;
    }
    if (sortDirection == "desc") {
      return <SvgImage name={"downArrow"} />;
    } else
      return (
        <>
          <SvgImage name={"arrowUp"} />
          <SvgImage name={"downArrow"} />
        </>
      );
  };

  const handlePageClick = (event) => {
    const newOffset = event.selected * 10;
    console.log("event heree", event.selected);
    // dispatch(
    //   viewBankStatement({
    //     offset: event.selected * 10,
    //     limit: 10,
    //     bankId: props.bankId,
    //     sortBy : sortedField == "Transaction Date" ? "expDate" : "amount",
    //     sortAs : sortDirection == "asc" ? "ASC" : "DESC"
    //     //   from : from,
    //     //   to : to,
    //     //   transferType : tripType == "0" ? "credit" : tripType == "1" ? "debit" : "",
    //     // startTime: moment(startDate).format("MM/DD/YYYY"),
    //     // endTime: moment(endDate).format("MM/DD/YYYY"),
    //     // search: search,
    //     // status: status,
    //   })
    // );
    setOffset(newOffset);
  };

  let columns;
  {
    bankStatementList?.map((i, k) => {
      columns = [
        {
          name: "S.No",
          width: "7%", // added line here
          selector: (i, k) => <>{parseFloat(k + 1)}</>,
        },
        {
          name: "Description",
          selector: (i) => (
            <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
              {i?.description}{" "}
            </div>
          ),
        },
        {
          name: "Credit",
          // width: "15%",
          selector: (i) => (
            <>{i?.transferType == "credit" ? "₹ " + i?.amount : ""}</>
          ),
        },
        {
          name: "Debit",
          // width: "15%",
          selector: (i) => (
            <>{i?.transferType == "debit" ? "₹ " + i?.amount : ""}</>
          ),
        },
        {
          name: "Closing Balance",
          // width: "15%",
          selector: (i) => <>₹ {i?.closingBal}</>,
        },
        // {
        //   name: "Remarks",
        //   selector: (i) => (i?.remarks ? i?.remarks : "NA"),
        // },
        // {
        //   name: "Total Expense",
        //   selector: (i) =>   0,
        // },
        {
          name: "Transaction Date",
          cell: (i) => (
            <div className="d-flex">
              {i?.expDate
                ? moment(i?.expDate, "YYYY-MM-DD HH:mm").format(
                    "DD/MM/YYYY HH:mm"
                  )
                : moment(i?.createdAt).format("DD/MM/YYYY HH:mm")}
            </div>
          ),
          // sortIcon: <CustomSortIcon />,
          sortable: true,
        },
        {
          name: "Map",
          cell: (i) => (
            <div
              className="d-flex"
              style={{
                cursor: "pointer",
                textDecorationLine: "underline",
                color: "blue",
              }}
              onClick={() => {
                if (i?.refData) {
                  if (i?.transferType == "credit") {
                    navigate(`/Customers/${i?.refData?.customerId}`);
                  }
                  if (i?.transferType == "debit") {
                    if (i?.refData?.givenTo == "Trip")
                      storeDataToAsyncStorage("row", i?.refData?.tripData);
                    navigate(`/trips/${i?.refData?.tripId}`);
                    if (i?.refData?.givenTo == "Driver")
                      navigate(
                        `/DriversV2/${i?.refData?.userId}?search=${i?.refData?.driverName}&offset=0`
                      );
                    if (i?.refData?.givenTo == "Vehicle_Expense")
                      navigate(
                        `/VehiclesV2/${i?.refData?.fleetId}?search=${i?.refData?.vrn}&offset=0`
                      );
                    if (i?.refData?.givenTo == "Vendor") navigate("");
                  }
                }
              }}
            >
              {i?.refData
                ? i?.transferType == "credit"
                  ? i?.refData?.customer
                  : i?.transferType == "debit"
                  ? i?.refData?.givenTo == "Trip"
                    ? i?.refData?.tripData?.tripNo
                    : i?.refData?.givenTo == "Driver"
                    ? i?.refData?.driverName
                    : i?.refData?.givenTo == "Vehicle_Expense"
                    ? i?.refData?.vrn
                    : i?.refData?.givenTo == "Vendor"
                    ? i?.refData?.vendor
                    : ""
                  : ""
                : ""}
            </div>
          ),
          // sortIcon: <CustomSortIcon />,
          sortable: true,
        },
        {
          name: "Action",
          cell: (i) => (
            <div className="row">
              <button
                className="btn btn-primary btn-sm col-6"
                style={{
                  width: "72px",
                  backgroundColor: i?.refId ? "green" : "#485b7c",
                }}
                onClick={() => {
                  if (!i?.refId) {
                    setStatement(i);
                    if (i?.transferType == "credit") {
                      showCustomerTxn(true);
                    } else showAddExpense(true);
                  }
                }}
              >
                {i?.refId ? "Mapped" : "Map"}
              </button>
              <button
                className="btn btn-primary btn-sm col-6"
                onClick={() => {
                  setStatement(i);
                  dispatch(
                    changeTxnStatusBank(
                      { bankLedgerId: i?.bankLedgerId },
                      (resp) => {
                        if (resp?.status == 200) {
                          bankStatementList.map((e) => {
                            if (e.bankLedgerId == i?.bankLedgerId) {
                              e["seen"] = 1;
                            }
                          });
                          console.log("jijijrei", bankStatementList);
                        }
                      }
                    )
                  );
                  // showAddExpense(true);
                }}
                style={{
                  width: "72px",
                  marginLeft: "1px",
                  marginTop: "2px",
                  backgroundColor: i["seen"] ? "green" : "#485b7c",
                }}
              >
                {i["seen"] ? "Verified" : "Verify"}
              </button>
            </div>
          ),
        },
      ];
    });
  }
  return (
    <div
      className="main-customer-vehicle-detail"
      style={{
        padding: "14px 25px 0px 25px",
      }}
    >
      <div className="closeBtnWithBackground" onClick={handleClose}>
        <SvgImage
          classname="close-btn-text"
          style={{ width: "10%", height: "10%" }}
          name="crossBtnWIthBackground"
          width="20%"
          height="20%"
        />
      </div>
      <div
      //   className="PGCollectionBox"
      >
        <div className="PGCollectiontText col-9">
          Statement {props?.bankId ? `- ${props?.accNumber}` : ""}
        </div>
        <div className="box4 d-flex">
          <div className="row">
            <div className="headingText col-12">Date Range:</div>
            <div className="col-12 row mt-2">
              <div className="col-5 row">
                {/* <input
                type="date"
                className="text-input-placeholder mt-2"
                placeholder={"Select Date"}
                onChange={(event) => {
                  setFrom(event.target.value);
                }}
                style={{width: "200px"}}
                max={to}
                value={from}
                // onkeypress={setStorage}
              /> */}
                <div className="col-9">
                  <DatePickerField
                    classname="searchBar-input1"
                    name="startDate"
                    header="From"
                    value={from}
                    onChange={(v) => {
                      setFrom(v);
                    }}
                    //onChange={(v) => setFieldValue("endDate", v, true)}
                    // maxDate={
                    //   values.endDate === "" ? "" : values.endDate
                    // }
                    // maxDate={new Date()}
                    // ref1={datepickerRefEnd}
                    style={{ width: "100px" }}
                  />
                </div>
                <div className="col-3" style={{ margin: "0 0 0 -12px" }}>
                  <label
                    className="date-input"
                    for="startDate"
                    style={{
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      //   handleClickDatepickerIcon2();
                    }}
                  >
                    <SvgImage
                      name="CalenderLogo"
                      width="32"
                      height="32"
                      // classname="date-logo"
                    />
                  </label>
                </div>
              </div>

              <div className="col-5 row">
                <div className="col-9">
                  <DatePickerField
                    classname="searchBar-input1"
                    name="startDate"
                    header="To"
                    value={to}
                    onChange={(v) => {
                      console.log("ppppoooooo", v);
                      setTo(v);
                    }}
                    //onChange={(v) => setFieldValue("endDate", v, true)}
                    // maxDate={
                    //   values.endDate === "" ? "" : values.endDate
                    // }
                    // maxDate={new Date()}
                    // ref1={datepickerRefEnd}
                    style={{ width: "100px" }}
                  />
                </div>
                <div className="col-3" style={{ margin: "0 0 0 -15px" }}>
                  <label
                    className="date-input"
                    for="startDate"
                    style={{
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      //   handleClickDatepickerIcon2();
                    }}
                  >
                    <SvgImage
                      name="CalenderLogo"
                      width="32"
                      height="32"
                      // classname="date-logo"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex box4 pt-0 justify-content-between">
          <div className="d-flex">
            <button
              className={`Medium heading3 ${
                transferType == "0"
                  ? "greenButtonMini"
                  : "greenOutlineButtonMini"
              } rounded-pill`}
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              onClick={(e) => {
                setTransferType("0");
                setOffset(0);
              }}
            >
              All
            </button>
            <button
              className={`Medium heading3 ${
                transferType == "1"
                  ? "greenButtonMini"
                  : "greenOutlineButtonMini"
              } rounded-pill ms-3`}
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              onClick={(e) => {
                setTransferType("1");
                setOffset(0);
              }}
            >
              Credit
            </button>
            <button
              className={`Medium heading3 ${
                transferType == "2"
                  ? "greenButtonMini"
                  : "greenOutlineButtonMini"
              } rounded-pill ms-3`}
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              onClick={(e) => {
                setTransferType("2");
                setOffset(0);
              }}
            >
              Debit
            </button>
            <button
              className={`Medium heading3 ${
                mode == "1" ? "greenButtonMini" : "greenOutlineButtonMini"
              } rounded-pill ms-3`}
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              onClick={(e) => {
                if (mode == "1") {
                  setMode("0");
                } else setMode("1");
                setOffset(0);
              }}
            >
              Verified
            </button>
            <button
              className={`Medium heading3 ${
                mode == "2" ? "greenButtonMini" : "greenOutlineButtonMini"
              } rounded-pill ms-3`}
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              onClick={(e) => {
                if (mode == "2") {
                  setMode("0");
                } else setMode("2");
                setOffset(0);
              }}
            >
              Mapped
            </button>
            {/* <button
            className={`Medium heading3 ${
              tripType == "0" ? "greenButtonMini" : "greenOutlineButtonMini"
            } rounded-pill ms-3`}
            style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
            onClick={(e) => {
              setTripType("2");
              setOffset(2);
            }}
          >
            Pending
          </button> */}
          </div>
        </div>
        <div>
          {bankStatementCount == undefined ||
          bankStatementListLoader ||
          (bankStatementCount > 0 && bankStatementList?.length == 0) ? (
            <div
              className="mt-2 boxContainer"
              style={{
                padding: 70,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <BallTriangle
                height={70}
                width={70}
                radius={5}
                color="#ED752E"
                ariaLabel="ball-triangle-loading"
                wrapperClass={{}}
                wrapperStyle=""
                visible={true}
              />
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={bankStatementList}
              customStyles={{
                headRow: {
                  style: {
                    backgroundColor: "#ededf1",
                    fontSize: "16px",
                    fontWeight: "bold",
                  },
                },
                cells: {
                  style: {
                    fontSize: "14px",
                    minHeight: "50px",
                  },
                },
              }}
              // fixedHeader
              // fixedHeaderScrollHeight='450px'
              // selectableRows
              selectableRowsHighlight
              highlightOnHover
              // sortFunction={customSort} // Use the custom sort function
              onSort={handleSort}
              sortField={sortedField} // Current sorted field
              sortDirection={sortDirection}
              sortIcon={<CustomSortIcon />}
              // onSelectedRowsChange={(row) => {
              //   console.log("njnjnfjnre", row);
              //   setCurrentRow(row?.selectedRows[0]);
              // }}
              // selectableRowSelected={(row) => {
              //   return row?.tripId == currentRow?.tripId;
              // }}
              // selectableRowsSingle={true}
              // pagination
              onRowClicked={(row) => {
                // onSelect(row);
              }}
              //   expandableRows
              //   expandableRowExpanded={(row) => {
              //     console.log("knnirii", row?.tripId == currentRow?.tripId);
              //     return row?.tripId == currentRow?.tripId;
              //   }}
              // expandableIcon={<></>}
              // expandableRowsHideExpander={true}
              // expandOnRowClicked
              // onRowClicked={(row) => setCurrentRow(row)}
              //   expandableRowsComponent={LrList}
              //   onRowExpandToggled={(bool, row) => {
              //     console.log("knnirijjjjji");
              //     setCurrentRow(row);
              //   }}
            />
          )}
        </div>
        <div className="reactPagination leftAlign">
          <ReactPaginate
            breakLabel="..."
            nextLabel=" >"
            // forcePage={parseFloat(offset)+1}
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            containerClassName={"pagination"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      </div>
      {addExpense ? (
        <EditLedgerExpense
          open={addExpense}
          ledgerData={statement}
          toggleModal={toggleAddExpense}
          handleClose={closeAddExpense}
          name="Edit Ledger"
          fleetId={props.fleetId}
          driverBal={"SCDa"}
          cardType={1}
          vehRegNo={props.vehRegNo}
          sortedField={sortedField}
          sortDirection={sortDirection}
          from={from}
          to={to}
          transferType={transferType}
          mode={mode}
          offset={offset}
          bankId={props.bankId}
        />
      ) : (
        <></>
      )}

      {addCustomerTxn ? (
        <MapCustomerLedger
          open={addCustomerTxn}
          ledgerData={statement}
          toggleModal={toggleACustomerTxn}
          handleClose={closeCustomerTxn}
          name="Edit Ledger"
          fleetId={props.fleetId}
          driverBal={"SCDa"}
          cardType={1}
          vehRegNo={props.vehRegNo}
          sortedField={sortedField}
          sortDirection={sortDirection}
          from={from}
          to={to}
          transferType={transferType}
          mode={mode}
          offset={offset}
          bankId={props.bankId}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

export default ViewBankStatment;
